// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errorBoundary":"css-1rrrUvCRyc","errorBoundary_button":"css-2j0syyOlSZ"};